import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { updateUserSuccess } from '../user/userSlice';
import { LyfshortUserProfile, SingupData } from '../../../types/authState'

// Define authentication state

export interface AuthState {
  isLyfshortLoggedIn: boolean;
  updating: boolean;
  loading: boolean;
  tempData: {
    signupData: SingupData;
    authData: object;
    user: LyfshortUserProfile;
  } | null;
  progress: string | null;
  shouldConfirmDetails: boolean;
  isLoggedIn: boolean;
  error: unknown | null;
}

const initialState: AuthState = {
  isLyfshortLoggedIn: false,
  updating: false,
  loading: true,
  tempData: null,
  progress: null,
  shouldConfirmDetails: false,
  isLoggedIn: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    lyfshortLogin: (state, action) => {
      state.updating = true
      state.loading = true
      state.progress = null
      state.shouldConfirmDetails = false
    },
    loginLyfshortFetchedUser: (state, action) => {
      state.updating = true
      state.tempData = {
        signupData: action.payload.signupData,
        authData: action.payload.authData,
        user: action.payload.user,
      }
      state.progress = 'check-user'
    },
    loginMissingMinimumUserDetails: (state) => {
      state.updating = true
      state.progress = 'get-user-details'
    },
    loginEmailUnverified: (state) => {
      state.updating = true
      state.progress = 'verify-email'
    },
    lyfshortLoginSuccess: (state, action) => {
      state.isLyfshortLoggedIn = true
      state.updating = false
      state.tempData = null
      state.progress = null
    },
    lyfshortLoginFailed: (state, action) => {
      state.updating = false
      state.isLyfshortLoggedIn = false
      state.tempData = null
      state.progress = null
      state.shouldConfirmDetails = false
      state.isLoggedIn = false
    },
    loginSetConfirmDetails: (state, action) => {
      state.shouldConfirmDetails = action.payload
    },
    login: (state) => {
      state.error = null
    },
    loginSuccess: (state, action) => {
      state.isLoggedIn = true
      state.loading = false
      state.error = null
    },
    loginFailed: (state, action) => {
      state.isLoggedIn = false
      state.loading = false
      state.error = action.payload
    },
    logout: (state) => {
      state.isLyfshortLoggedIn = false
      state.tempData = null
      state.progress = null
      state.shouldConfirmDetails = false
      state.isLoggedIn = false
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updateUserSuccess, (state, action) => {
        if (state.updating && state.tempData && state.tempData.user) {
          state.tempData = {
            ...state.tempData,
            user: action.payload.user,
          }
        }
      })
  },
});

export const {
  lyfshortLogin,
  lyfshortLoginSuccess,
  lyfshortLoginFailed,
  logout,
  loginLyfshortFetchedUser,
  loginMissingMinimumUserDetails,
  loginEmailUnverified,
  loginSetConfirmDetails,
  login,
  loginSuccess,
  loginFailed,
} = authSlice.actions
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;
